export default __webpack_public_path__ + "static/media/close-app-ill.d3248041.svg";